import { SwarovskiOptikLocale } from "@swo/shared";
import { useMemo } from "react";
import { SwarovskiOptikLocaleFrontend } from "@swo/storefront";

export function useLocaleLanguageEnglishName(locale: SwarovskiOptikLocaleFrontend) {
  return useMemo(() => getLocaleLanguageEnglishName(locale), [locale]);
}

export function getLocaleLanguageEnglishName(locale: SwarovskiOptikLocaleFrontend): string {
  const localeWithInternationalFallback = locale.language.isoCode;
  const fallback = "english";

  try {
    return (
      new Intl.DisplayNames(["en"], { type: "language", style: "short" })
        .of(localeWithInternationalFallback)
        ?.toLowerCase() || fallback
    );
  } catch {
    return fallback;
  }
}
